import { render, staticRenderFns } from "./CustomerForm.vue?vue&type=template&id=f8601d3c&scoped=true&lang=html&"
import script from "./CustomerForm.vue?vue&type=script&lang=js&"
export * from "./CustomerForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomerForm.vue?vue&type=style&index=0&id=f8601d3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8601d3c",
  null
  
)

export default component.exports